import { render, staticRenderFns } from "./TermosConfiguracaoTabela.vue?vue&type=template&id=32ff7cfc"
import script from "./TermosConfiguracaoTabela.vue?vue&type=script&lang=js"
export * from "./TermosConfiguracaoTabela.vue?vue&type=script&lang=js"
import style0 from "./TermosConfiguracaoTabela.vue?vue&type=style&index=0&id=32ff7cfc&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports